import styled from 'styled-components';

export const ToastContainer = styled.div`
  box-sizing: border-box;
  z-index: ${({ theme }) => theme._ui.chatPanel.zIndex};
  position: fixed;
  bottom: 5.5rem;
  right: ${({ theme }) => theme.spacing.xl};
  width: 343px;
  min-height: 6rem;

  border-radius: ${({ theme }) => theme.borderRadius.xl};

  padding: ${({ theme }) => theme.spacing.xl};

  background: ${({ theme }) => theme.background.strong};
`;

export const ToastContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xl};
  justify-content: flex-start;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  text-align: start;
  padding-right: 3rem;
`;

export const CloseContainer = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.text.inverse};
  position: absolute;
  top: ${({ theme }) => theme.spacing['2Xl']};
  right: ${({ theme }) => theme.spacing['2Xl']};
`;
